<template>
  <div>
    <div class="home w-100vh">
      <!-- Header -->
      <div class="container p-0" id="top">
        <img src="@/assets/img/header-scholarship.png" alt="header" width="100%" />
      </div>
      <!-- Header -->
      <!-- Body -->
      <div class="container">
        <div class="row bg_ffffff">
          <div class="col-12 col-sm-12 padding_30 padding_top_0">
            <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
              <div class="p-500">
                <center>
                  <h3>ท่านได้สมัครขอรับทุนการศึกษาเรียบร้อยแล้ว</h3>
                  <p class="fs-5">รอการติดต่อกลับในภายหลัง</p>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Body -->
      <!-- Footer -->
      <div class="container p-0">
        <img src="@/assets/img/footer.png" alt="header" width="100%" />
      </div>
      <!-- Footer -->
    </div>
  </div>
</template>

<script>
import pdfMake from "pdfmake";
import axios from "axios";
import pdfFonts from "@/assets/js/custom-fonts.js"; // 1. import custom fonts
import * as cpf from "@/assets/js/logo.js"; // 1. import custom fonts
export default {
  name: "App",
  data() {
    return {
      logo: cpf.logo,
      background: cpf.backgroud,
      pdfFile: null,
      scholarship: null,
      income: null,
      advisor: null,
      RandomID: null,
      filelist: [],
      PDFFile: null,
      PDFName: null,
      // BaseURL: "http://localhost:8085/form/scholarship/",
      // BaseAPI: "http://localhost:8083/",

      BaseURL: "https://tica.or.th/uploads/form/scholarship-cpf/",
      BaseAPI: "https://tica.or.th/uploads/form/scholarship-cpf/images/save/",
    };
  },
  async created() {
    await this.mapData();
    this.PDFName =
      location.protocol +
      "//" +
      location.hostname +
      "/uploads/form/scholarship-cpf/images/save/assets/img/" +
      (await sessionStorage.getItem("UID")) +
      "/profile/studentDetail.pdf";
  },
  async mounted() {
    await this.export();
    setTimeout(await this.sendEmail(), 2000);
  },
  methods: {
    async export() {
      const BaseURL = this.BaseURL;
      pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
      pdfMake.fonts = {
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
        },
        // Kanit Font
        Sarabun: {
          normal: "Sarabun-Light.ttf",
          bold: "Sarabun-Regular.ttf",
          italics: "Sarabun-Italic.ttf",
          bolditalics: "Sarabun-SemiBoldItalic.ttf",
        },
      };
      const docDefinition = {
        pageSize: "LETTER",
        pageMargins: [40, 60, 40, 60],
        background: function (currentPage, pageSize) {
          return [{ image: `background${currentPage}`, width: 595.28 }];
        },
        content: [
          {
            text: "",
            margin: [0, 0, 0, 0],
            fontSize: 10,
          },
          // {
          //   image: `studentProfile`,
          //   height: 90,
          //   width: 100,
          //   absolutePosition: { x: 460, y: 43 },
          // },
          {
            // ชื่อ
            text: this.scholarship.Profile.Title + " " + this.scholarship.Profile.NameTH,
            absolutePosition: { x: 170, y: 126 },
            fontSize: 10,
          },
          {
            // สกุล
            text: this.scholarship.Profile.LastnameTH,
            absolutePosition: { x: 360, y: 126 },
            fontSize: 10,
          },
          {
            // ชื่อ-สกุล Eng
            text: this.scholarship.Profile.NameEN,
            absolutePosition: { x: 170, y: 143 },
            fontSize: 10,
          },
          {
            // สถานศึกษา
            text: this.scholarship.Profile.StudyingAtTheInstitute,
            absolutePosition: { x: 200, y: 159 },
            fontSize: 10,
          },
          {
            //  คะน้า คะแนะ คณะ
            text: this.scholarship.Profile.Faculty,
            absolutePosition: { x: 130, y: 176 },
            fontSize: 10,
          },
          {
            // สาขาวิชา
            text: this.scholarship.Profile.Major,
            absolutePosition: { x: 370, y: 176 },
            fontSize: 10,
          },
          {
            //  รหัสนักศึกษา
            text: this.scholarship.Profile.StudentCode,
            absolutePosition: { x: 130, y: 193 },
            fontSize: 10,
          },
          {
            //  ชั้นปี
            text: this.scholarship.Profile.YearClass,
            absolutePosition: { x: 350, y: 193 },
            fontSize: 10,
          },
          {
            //  GPA ล่าสุด
            text: this.scholarship.Profile.AverageScoreNow,
            absolutePosition: { x: 195, y: 210 },
            fontSize: 10,
          },
          {
            //  วันเกิด
            text: this.scholarship.Profile.DateOfBirth,
            absolutePosition: { x: 300, y: 210 },
            fontSize: 10,
          },
          {
            //  สถานที่เกิด
            text: this.scholarship.Profile.PlaceOfBirth,
            absolutePosition: { x: 410, y: 210 },
            fontSize: 10,
          },
          {
            //  ศาสนา
            text: this.scholarship.Profile.Religion,
            absolutePosition: { x: 150, y: 226 },
            fontSize: 10,
          },
          {
            //  บ้านเลขที่
            text: this.scholarship.Profile.Domicile.Number,
            absolutePosition: { x: 400, y: 226 },
            fontSize: 10,
          },
          {
            //  หมู่ที่
            text: this.scholarship.Profile.Domicile.Moo,
            absolutePosition: { x: 460, y: 226 },
            fontSize: 10,
          },
          {
            //  ถนน
            text: this.scholarship.Profile.Domicile.Road,
            absolutePosition: { x: 130, y: 242 },
            fontSize: 10,
          },
          {
            //  ตำบล
            text: this.scholarship.Profile.Domicile.Tambon,
            absolutePosition: { x: 245, y: 242 },
            fontSize: 10,
          },
          {
            //  อำเภอ
            text: this.scholarship.Profile.Domicile.District,
            absolutePosition: { x: 350, y: 242 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.Profile.Domicile.Province,
            absolutePosition: { x: 460, y: 242 },
            fontSize: 10,
          },
          {
            //  รหัสไปรษณีย์
            text: this.scholarship.Profile.Domicile.Postcode,
            absolutePosition: { x: 170, y: 258 },
            fontSize: 10,
          },
          {
            //  หมายเลขโทรศัพท์
            text: this.scholarship.Profile.Domicile.Phone,
            absolutePosition: { x: 290, y: 258 },
            fontSize: 10,
          },
          {
            //  โทรศัพท์มือถือ
            text: this.scholarship.Profile.Domicile.Mobile,
            absolutePosition: { x: 435, y: 258 },
            fontSize: 10,
          },
          // ที่อยู่ที่ติดต่อได้สะดวก
          {
            //  บ้านเลขที่
            text: this.scholarship.Profile.CurrentAddress.Number,
            absolutePosition: { x: 280, y: 275 },
            fontSize: 10,
          },
          {
            //  หมู่ที่
            text: this.scholarship.Profile.CurrentAddress.Moo,
            absolutePosition: { x: 365, y: 275 },
            fontSize: 10,
          },
          {
            //  ถนน
            text: this.scholarship.Profile.CurrentAddress.Road,
            absolutePosition: { x: 435, y: 275 },
            fontSize: 10,
          },
          {
            //  ตำบล
            text: this.scholarship.Profile.CurrentAddress.Tambon,
            absolutePosition: { x: 140, y: 291 },
            fontSize: 10,
          },
          {
            //  อำเภอ
            text: this.scholarship.Profile.CurrentAddress.District,
            absolutePosition: { x: 240, y: 291 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.Profile.CurrentAddress.Province,
            absolutePosition: { x: 340, y: 291 },
            fontSize: 10,
          },
          {
            //  รหัสไปรษณีย์
            text: this.scholarship.Profile.CurrentAddress.Postcode,
            absolutePosition: { x: 480, y: 291 },
            fontSize: 10,
          },
          {
            //  หมายเลขโทรศัพท์
            text: this.scholarship.Profile.CurrentAddress.Phone,
            absolutePosition: { x: 190, y: 308 },
            fontSize: 10,
          },
          {
            //  โทรศัพท์มือถือ
            text: this.scholarship.Profile.CurrentAddress.Mobile,
            absolutePosition: { x: 335, y: 308 },
            fontSize: 10,
          },

          // // ประวัติการศึกษาโดยย่อ
          {
            //  โรงเรียนประถม
            text: this.scholarship.BriefEducationalBackground.PrimarySchool.Name,
            absolutePosition: { x: 250, y: 351 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.BriefEducationalBackground.PrimarySchool.Province,
            absolutePosition: { x: 435, y: 351 },
            fontSize: 10,
          },
          {
            //  โรงเรียนมัธยมต้น
            text: this.scholarship.BriefEducationalBackground.JuniorHighSchool.Name,
            absolutePosition: { x: 250, y: 368 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.BriefEducationalBackground.JuniorHighSchool.Province,
            absolutePosition: { x: 435, y: 368 },
            fontSize: 10,
          },
          {
            //  โรงเรียนมัธยมปลาย
            text: this.scholarship.BriefEducationalBackground.HighSchool.Name,
            absolutePosition: { x: 250, y: 386 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.BriefEducationalBackground.HighSchool.Province,
            absolutePosition: { x: 435, y: 386 },
            fontSize: 10,
          },
          {
            //  GPA เฉลี่ย
            text: this.scholarship.BriefEducationalBackground.CumulativeGPA,
            absolutePosition: { x: 325, y: 404 },
            fontSize: 10,
          },

          // สถาณภาพครัวบครัวผู้ขอทุน
          {
            //  ชื่อบิดา
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Name,
            absolutePosition: { x: 140, y: 454 },
            fontSize: 10,
          },
          {
            //  อายุ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Age,
            absolutePosition: { x: 260, y: 454 },
            fontSize: 10,
          },
          {
            //  อายุ
            text: "/",
            absolutePosition: {
              x:
                this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Alive == 0
                  ? 410
                  : 348,
              y: 453,
            },
            fontSize: 10,
          },
          {
            //  อาชีพ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father
              .Occupation,
            margin: [100, 4, 0, 0],
            absolutePosition: { x: 140, y: 470 },
            fontSize: 10,
          },
          {
            //  ลักษณะงาน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father
              .NatureOfWork,
            margin: [330, -13, 0, 0],
            absolutePosition: { x: 370, y: 470 },
            fontSize: 10,
          },
          {
            //  ตำแหน่ว/ยศ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Position,
            absolutePosition: { x: 160, y: 485 },
            fontSize: 10,
          },
          {
            //  รายได้ต่อเดือน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father
              .MonthlyIncome,
            absolutePosition: { x: 400, y: 485 },
            fontSize: 10,
          },
          {
            //  สถาณที่ทำงาน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Workplace,
            absolutePosition: { x: 160, y: 502 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Province,
            absolutePosition: { x: 400, y: 502 },
            fontSize: 10,
          },
          {
            //  โทรศัพท์
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Phone,
            absolutePosition: { x: 140, y: 518 },
            fontSize: 10,
          },
          {
            //  มือถือ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Father.Mobile,
            absolutePosition: { x: 370, y: 518 },
            fontSize: 10,
          },

          {
            //  ชื่อมารดา
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Name,
            absolutePosition: { x: 150, y: 545 },
            fontSize: 10,
          },
          {
            //  อายุ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Age,
            absolutePosition: { x: 260, y: 545 },
            fontSize: 10,
          },
          {
            //  อายุ
            text: "/",
            absolutePosition: {
              x:
                this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Alive == 0
                  ? 410
                  : 348,
              y: 545,
            },
            fontSize: 10,
          },
          {
            //  อาชีพ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother
              .Occupation,
            absolutePosition: { x: 160, y: 561 },
            fontSize: 10,
          },
          {
            //  ลักษณะงาน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother
              .NatureOfWork,
            absolutePosition: { x: 370, y: 561 },
            fontSize: 10,
          },
          {
            //  ตำแหน่ว/ยศ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Position,
            absolutePosition: { x: 160, y: 576 },
            fontSize: 10,
          },
          {
            //  รายได้ต่อเดือน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother
              .MonthlyIncome,
            absolutePosition: { x: 400, y: 576 },
            fontSize: 10,
          },
          {
            //  สถาณที่ทำงาน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Workplace,
            absolutePosition: { x: 160, y: 593 },
            fontSize: 10,
          },
          {
            //  จังหวัด
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Province,
            absolutePosition: { x: 350, y: 593 },
            fontSize: 10,
          },
          {
            //  โทรศัพท์
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Phone,
            margin: [100, 3, 0, 0],
            absolutePosition: { x: 140, y: 609 },
            fontSize: 10,
          },
          {
            //  มือถือ
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Mother.Mobile,
            absolutePosition: { x: 370, y: 609 },
            fontSize: 10,
          },

          {
            //  อยู่กับ บิดามารดา
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                .Status == 0
                ? "/"
                : " ",
            absolutePosition: { x: 107, y: 638 },
            fontSize: 10,
          },
          {
            //  อยู่กับคนอื่น
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                .Status == 1
                ? "/"
                : " ",
            absolutePosition: { x: 336, y: 638 },
            fontSize: 10,
          },
          {
            //  เช่าบ้าน
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                .Status == 2
                ? "/"
                : " ",
            absolutePosition: { x: 107, y: 654 },
            fontSize: 10,
          },
          {
            // ค่าเช่าบ้าน
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                .Status == 2
                ? this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                    .MonthlyRent
                : " ",
            absolutePosition: { x: 235, y: 654 },
            fontSize: 10,
          },
          {
            //  เช่าที่ดิน
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                .Status == 3
                ? "/"
                : " ",
            absolutePosition: { x: 107, y: 669 },
            fontSize: 10,
          },

          {
            // ค่าเช่าที่ดิน
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                .Status == 3
                ? this.scholarship.FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                    .MonthlyRent
                : " ",
            absolutePosition: { x: 235, y: 669 },
            fontSize: 10,
          },

          {
            // สถานะของบิดามารดา (อยู่เด้ยวกัน)
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.RelationshipStatus ==
              0
                ? "/"
                : " ",
            absolutePosition: { x: 107, y: 686 },
            fontSize: 10,
          },
          {
            // สถานะของบิดามารดา (แยกกันอยู่)
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.RelationshipStatus ==
              1
                ? "/"
                : " ",
            absolutePosition: { x: 252, y: 686 },
            fontSize: 10,
          },
          {
            // สถานะของบิดามารดา (หย่า)
            text:
              this.scholarship.FamilyStatusOfTheScholarshipApplicant.RelationshipStatus ==
              2
                ? "/"
                : " ",
            absolutePosition: { x: 384, y: 686 },
            fontSize: 10,
          },
          {
            // มีพี่น้องกี่คน
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Siblings.Number,
            absolutePosition: { x: 230, y: 702 },
            fontSize: 10,
          },
          {
            // เป็นบุตรคนที่
            text: this.scholarship.FamilyStatusOfTheScholarshipApplicant.Siblings
              .ChildCurrent,
            absolutePosition: { x: 405, y: 702 },
            fontSize: 10,
          },
          // page 2
          {
            layout: "noBorders", // optional
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              widths: [26, 180, 70, 80],

              body: await this.mapDataSiblingEducationAndCareer(),
            },
            fontSize: 10,
            pageOrientation: "portrait",
            pageBreak: "before",
            absolutePosition: { x: 130, y: 94 },
          },
          {
            text: this.scholarship.Patron.Name,
            absolutePosition: { x: 270, y: 222 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Relations,
            absolutePosition: { x: 450, y: 222 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Number,
            absolutePosition: { x: 235, y: 238 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Moo,
            absolutePosition: { x: 295, y: 238 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Road,
            absolutePosition: { x: 345, y: 238 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Tambon,
            absolutePosition: { x: 465, y: 238 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.District,
            absolutePosition: { x: 150, y: 254 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Province,
            absolutePosition: { x: 290, y: 254 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Postcode,
            absolutePosition: { x: 465, y: 254 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Occupation,
            absolutePosition: { x: 200, y: 270 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Position,
            absolutePosition: { x: 390, y: 270 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Workplace,
            absolutePosition: { x: 170, y: 287 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Phone,
            absolutePosition: { x: 315, y: 287 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Mobile,
            absolutePosition: { x: 450, y: 287 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.SponsorCount,
            absolutePosition: { x: 255, y: 305 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Patron.Sibling,
            absolutePosition: { x: 375, y: 305 },
            fontSize: 10,
          },
          // สถาพการอยู่อาศัยของผู้ขอทุน

          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 0 ? "/" : " ",
            absolutePosition: { x: 93, y: 347 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 1 ? "/" : " ",
            absolutePosition: { x: 224, y: 347 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 2 ? "/" : " ",
            absolutePosition: { x: 315, y: 347 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 3 ? "/" : " ",
            absolutePosition: { x: 381, y: 347 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 4 ? "/" : " ",
            absolutePosition: { x: 93, y: 364 },
            fontSize: 10,
          },
          // detail
          {
            text:
              this.scholarship.ApplicantDetail.Dormitory.status == 4
                ? this.scholarship.ApplicantDetail.Dormitory.Detail.name
                : " ",
            absolutePosition: { x: 170, y: 364 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.ApplicantDetail.Dormitory.status == 4
                ? this.scholarship.ApplicantDetail.Dormitory.Detail.locations
                : " ",
            absolutePosition: { x: 310, y: 364 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.ApplicantDetail.Dormitory.status == 4
                ? this.scholarship.ApplicantDetail.Dormitory.Detail.room
                : " ",
            absolutePosition: { x: 130, y: 381 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.ApplicantDetail.Dormitory.status == 4
                ? this.scholarship.ApplicantDetail.Dormitory.Detail.mobile
                : " ",
            absolutePosition: { x: 230, y: 381 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.ApplicantDetail.Dormitory.status == 4
                ? this.scholarship.ApplicantDetail.Dormitory.Detail.price
                : " ",
            absolutePosition: { x: 340, y: 381 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 5 ? "/" : " ",
            absolutePosition: { x: 93, y: 399 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ApplicantDetail.Dormitory.status == 6 ? "/" : " ",
            absolutePosition: { x: 93, y: 415 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.ApplicantDetail.Dormitory.status == 6
                ? this.scholarship.ApplicantDetail.Dormitory.Other
                : " ",
            absolutePosition: { x: 140, y: 415 },
            fontSize: 10,
          },
          //  รายได้ รายจ่าย ของผู้ขอทุน
          {
            text:
              this.scholarship.IncomeAndExpenses.DailyIncome.IncomeType == 0 ? "/" : " ",
            absolutePosition: { x: 185, y: 465 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.IncomeAndExpenses.DailyIncome.IncomeType == 1 ? "/" : " ",
            margin: [218, -13, 0, 0],
            absolutePosition: { x: 258, y: 465 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.IncomeAndExpenses.DailyIncome.IncomeType == 2 ? "/" : " ",
            absolutePosition: { x: 340, y: 465 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.DailyIncome.PerDay,
            absolutePosition: { x: 450, y: 465 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.BreakFast.Location == 0 ? "/" : " ",
            absolutePosition: { x: 110, y: 482 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.BreakFast.Location == 1 ? "/" : " ",
            absolutePosition: { x: 258, y: 482 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.BreakFast.Location == 2 ? "/" : " ",
            absolutePosition: { x: 356, y: 482 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.BreakFast.Price,
            absolutePosition: { x: 452, y: 482 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.lunch.Location == 0 ? "/" : " ",
            absolutePosition: { x: 110, y: 499 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.lunch.Location == 1 ? "/" : " ",
            absolutePosition: { x: 258, y: 499 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.lunch.Location == 2 ? "/" : " ",
            absolutePosition: { x: 356, y: 499 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.lunch.Price,
            absolutePosition: { x: 452, y: 499 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.dinner.Location == 0 ? "/" : " ",
            absolutePosition: { x: 110, y: 516 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.dinner.Location == 1 ? "/" : " ",
            absolutePosition: { x: 258, y: 516 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.dinner.Location == 2 ? "/" : " ",
            absolutePosition: { x: 356, y: 516 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.dinner.Price,
            absolutePosition: { x: 452, y: 516 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.ApproximateTravelExpenses,
            absolutePosition: { x: 260, y: 531 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.EducationExpenses,
            absolutePosition: { x: 210, y: 547 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.OtherExpenses,
            absolutePosition: { x: 180, y: 565 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.EarnExtraMoney.Detail,
            absolutePosition: { x: 265, y: 585 },
            fontSize: 10,
          },
          {
            text: this.scholarship.IncomeAndExpenses.EarnExtraMoney.price,
            absolutePosition: { x: 190, y: 602 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 0
                ? "/"
                : " ",
            absolutePosition: { x: 93, y: 636 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? "/"
                : " ",
            absolutePosition: { x: 93, y: 651 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Name
                : " ",
            absolutePosition: { x: 215, y: 651 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Year
                : " ",
            absolutePosition: { x: 430, y: 651 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Type.Name == 0 &&
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? "/"
                : " ",
            absolutePosition: { x: 225, y: 667 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Type.Name == 0 &&
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Type.Price
                : " ",
            absolutePosition: { x: 310, y: 667 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Type.Name == 1 &&
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? "/"
                : " ",
            absolutePosition: { x: 225, y: 684 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Type.Name == 1 &&
              this.scholarship.OtherScholarshipsPreviouslyAwarded.ScholarshipsHistoty == 1
                ? this.scholarship.OtherScholarshipsPreviouslyAwarded.detail.Type.Price
                : " ",
            absolutePosition: { x: 370, y: 684 },
            fontSize: 10,
          },
          {
            text: this.scholarship.GovernmentScholarships.Year,
            absolutePosition: { x: 250, y: 701 },
            fontSize: 10,
          },
          {
            text: this.scholarship.GovernmentScholarships.Price,
            absolutePosition: { x: 370, y: 701 },
            fontSize: 10,
          },

          //  page 3
          {
            text: this.scholarship.SpecialEventsAttended.AcademicActivities,
            absolutePosition: { x: 190, y: 77 },
            fontSize: 10,
            pageOrientation: "portrait",
            pageBreak: "before",
          },
          {
            text: this.scholarship.SpecialEventsAttended.PublicInterestActivities,
            absolutePosition: { x: 240, y: 93 },
            fontSize: 10,
          },
          {
            text: this.scholarship.SpecialEventsAttended.SportsActivities,
            absolutePosition: { x: 180, y: 110 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.name,
            absolutePosition: { x: 120, y: 144 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.relations,
            absolutePosition: { x: 320, y: 144 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.Number,
            absolutePosition: { x: 490, y: 144 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.Road,
            absolutePosition: { x: 130, y: 161 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.Tambon,
            absolutePosition: { x: 240, y: 161 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.District,
            absolutePosition: { x: 350, y: 161 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.Province,
            absolutePosition: { x: 470, y: 161 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.Phone,
            absolutePosition: { x: 190, y: 176 },
            fontSize: 10,
          },
          {
            text: this.scholarship.ProvideAdditionalInformation.Mobile,
            absolutePosition: { x: 350, y: 176 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Talent + "",
            absolutePosition: { x: 110, y: 208 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.HealthProblems.CongenitalDisease.Status == 0 ? "/" : " ",
            absolutePosition: { x: 192, y: 290 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.HealthProblems.CongenitalDisease.Status == 0
                ? this.scholarship.HealthProblems.CongenitalDisease.Detail
                : " ",
            absolutePosition: { x: 240, y: 289 },
            fontSize: 10,
          },
          {
            text:
              this.scholarship.HealthProblems.CongenitalDisease.Status == 1 ? "/" : " ",
            absolutePosition: { x: 357, y: 290 },
            fontSize: 10,
          },
          {
            text: this.scholarship.HealthProblems.OtherProblems,
            absolutePosition: { x: 120, y: 322 },
            fontSize: 10,
          },
          {
            text: this.scholarship.HealthProblems.FamilyProblems,
            absolutePosition: { x: 120, y: 372 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Advisor,
            absolutePosition: { x: 180, y: 425 },
            fontSize: 10,
          },
          {
            image: `studentSignature`,
            height: 35,
            width: 100,
            absolutePosition: { x: 320, y: 485 },
          },
          {
            text: this.scholarship.Signature.Name,
            absolutePosition: { x: 330, y: 530 },
            fontSize: 10,
          },
          {
            text: this.scholarship.Signature.Date,
            absolutePosition: { x: 348, y: 547 },
            fontSize: 10,
          },

          // page 4
          {
            text: `\t\t\t${this.scholarship.DescriptionOfFamilyHistory}`,
            absolutePosition: { x: 60, y: 100 },
            alignment: "justify",
            fontSize: 10,
            pageOrientation: "portrait",
            pageBreak: "before",
          },
          // page 5
          // {
          //   image: `mapLocations`,
          //   width: 500,
          //   margin: [20, 40, 0, 0],
          //   pageOrientation: "portrait",
          //   alignment: "center",
          //   pageBreak: "before",
          // },
          // {
          //   text: "",
          //   absolutePosition: { x: 0, y: 76 },
          //   pageOrientation: "portrait",
          //   pageBreak: "before",
          // },
          // page 6
          {
            text: this.income.Profile.date,
            absolutePosition: { x: 440, y: 76 },
            pageOrientation: "portrait",
            pageBreak: "before",
            fontSize: 10,
          },
          {
            text: this.income.Profile.Name,
            absolutePosition: { x: 168, y: 90 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Positions,
            absolutePosition: { x: 420, y: 90 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Workplace,
            absolutePosition: { x: 155, y: 105 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Number,
            absolutePosition: { x: 440, y: 105 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Moo,
            absolutePosition: { x: 505, y: 105 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Soi,
            absolutePosition: { x: 150, y: 120 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Road,
            absolutePosition: { x: 285, y: 120 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Tambon,
            absolutePosition: { x: 445, y: 120 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.District,
            absolutePosition: { x: 150, y: 134 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Province,
            absolutePosition: { x: 285, y: 134 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Postcode,
            absolutePosition: { x: 460, y: 134 },
            fontSize: 10,
          },
          {
            text: this.income.Profile.Mobile,
            absolutePosition: { x: 140, y: 149 },
            fontSize: 9,
          },
          {
            text: this.income.Father.Name,
            absolutePosition: { x: 200, y: 165 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Age,
            absolutePosition: { x: 390, y: 165 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Alive.Status == 0 ? "/" : " ",
            absolutePosition: { x: 429, y: 165 },
            fontSize: 10,
          },
          {
            text:
              this.income.Father.Alive.Status == 0 ? this.income.Father.Alive.Year : "",
            absolutePosition: { x: 490, y: 165 },
            fontSize: 10,
          },
          {
            text: this.income.Father.FatherOfName,
            absolutePosition: { x: 140, y: 180 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Occupation,
            absolutePosition: { x: 415, y: 180 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Workplace,
            absolutePosition: { x: 155, y: 194 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Number,
            absolutePosition: { x: 455, y: 194 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Moo,
            absolutePosition: { x: 518, y: 194 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Soi,
            absolutePosition: { x: 155, y: 208 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Road,
            absolutePosition: { x: 285, y: 208 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Tambon,
            absolutePosition: { x: 445, y: 208 },
            fontSize: 10,
          },
          {
            text: this.income.Father.District,
            absolutePosition: { x: 155, y: 223 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Province,
            absolutePosition: { x: 275, y: 223 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Postcode,
            absolutePosition: { x: 470, y: 223 },
            fontSize: 10,
          },
          {
            text: this.income.Father.Phone,
            absolutePosition: { x: 140, y: 238 },
            fontSize: 9,
          },
          {
            text: this.income.Father.Income,
            absolutePosition: { x: 295, y: 238 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Name,
            absolutePosition: { x: 190, y: 257 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Age,
            absolutePosition: { x: 390, y: 257 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Alive.Status == 1 ? "/" : " ",
            absolutePosition: { x: 429, y: 258 },
            fontSize: 10,
          },
          {
            text:
              this.income.Mother.Alive.Status == 1 ? this.income.Mother.Alive.Year : "",
            absolutePosition: { x: 490, y: 257 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.MotherOfName,
            absolutePosition: { x: 140, y: 271 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Occupation,
            absolutePosition: { x: 415, y: 271 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Workplace,
            absolutePosition: { x: 155, y: 285 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Number,
            absolutePosition: { x: 440, y: 285 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Moo,
            absolutePosition: { x: 510, y: 285 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Soi,
            absolutePosition: { x: 155, y: 301 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Road,
            absolutePosition: { x: 285, y: 301 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Tambon,
            absolutePosition: { x: 445, y: 301 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.District,
            absolutePosition: { x: 155, y: 315 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Province,
            absolutePosition: { x: 285, y: 315 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Postcode,
            absolutePosition: { x: 470, y: 315 },
            fontSize: 10,
          },
          {
            text: this.income.Mother.Phone,
            absolutePosition: { x: 140, y: 329 },
            fontSize: 9,
          },
          {
            text: this.income.Mother.Income,
            absolutePosition: { x: 295, y: 329 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Name,
            absolutePosition: { x: 260, y: 343 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.ScholarshipApplicantName,
            absolutePosition: { x: 155, y: 357 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Occupation,
            absolutePosition: { x: 440, y: 357 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Workplace,
            absolutePosition: { x: 155, y: 372 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Number,
            absolutePosition: { x: 440, y: 372 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Moo,
            absolutePosition: { x: 510, y: 372 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Soi,
            absolutePosition: { x: 155, y: 387 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Road,
            absolutePosition: { x: 285, y: 387 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Tambon,
            absolutePosition: { x: 445, y: 387 },
            fontSize: 10,
          },

          {
            text: this.income.NotMotherFather.District,
            absolutePosition: { x: 155, y: 401 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Province,
            absolutePosition: { x: 285, y: 401 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Postcode,
            absolutePosition: { x: 470, y: 401 },
            fontSize: 10,
          },
          {
            text: this.income.NotMotherFather.Phone,
            absolutePosition: { x: 140, y: 417 },
            fontSize: 9,
          },
          {
            text: this.income.NotMotherFather.Income,
            absolutePosition: { x: 295, y: 417 },
            fontSize: 10,
          },
          {
            image: `incomeSignature`,
            height: 35,
            width: 100,
            absolutePosition: { x: 330, y: 487 },
          },
          {
            text: this.income.Signature.Name,
            absolutePosition: { x: 350, y: 534 },
            fontSize: 10,
          },
          {
            text: this.income.Signature.Positions,
            absolutePosition: { x: 360, y: 548 },
            fontSize: 10,
          },
          // page 7
          {
            text: this.advisor.title + this.advisor.Name,
            absolutePosition: { x: 190, y: 142 },
            pageOrientation: "portrait",
            pageBreak: "before",
            fontSize: 10,
          },
          {
            text: this.advisor.Number,
            absolutePosition: { x: 460, y: 142 },
            fontSize: 10,
          },
          {
            text: this.advisor.Faculty,
            absolutePosition: { x: 120, y: 157 },
            fontSize: 10,
          },
          {
            text: this.advisor.Major,
            absolutePosition: { x: 290, y: 157 },
            fontSize: 10,
          },
          {
            text: this.advisor.YearClass,
            absolutePosition: { x: 470, y: 157 },
            fontSize: 10,
          },
          {
            text: this.advisor.EconomicStatusOfTheApplicant.Occupation,
            absolutePosition: { x: 320, y: 188 },
            fontSize: 10,
          },
          {
            text: this.advisor.EconomicStatusOfTheApplicant.Income,
            absolutePosition: { x: 290, y: 204 },
            fontSize: 10,
          },
          {
            text: this.advisor.EconomicStatusOfTheApplicant.Scarcity,
            absolutePosition: { x: 130, y: 233 },
            fontSize: 10,
          },
          {
            text: this.advisor.DailyLife.EarnExtraMoney,
            absolutePosition: { x: 130, y: 281 },
            fontSize: 10,
          },
          {
            text: this.advisor.DailyLife.Activities,
            absolutePosition: { x: 130, y: 311 },
            fontSize: 10,
          },
          {
            text: this.advisor.DailyLife.Health,
            absolutePosition: { x: 180, y: 328 },
            fontSize: 10,
          },
          {
            text: this.advisor.DailyLife.Behavior,
            absolutePosition: { x: 200, y: 344 },
            fontSize: 10,
          },
          {
            text: this.advisor.Education.StudySnterest,
            absolutePosition: { x: 130, y: 388 },
            fontSize: 10,
          },
          {
            text: this.advisor.ReasonAndNecessity,
            absolutePosition: { x: 130, y: 435 },
            fontSize: 10,
          },
          {
            text: this.advisor.Consideration.Status == 0 ? "/" : "",
            absolutePosition: { x: 115, y: 489 },
            fontSize: 10,
          },
          {
            text:
              this.advisor.Consideration.Status == 0
                ? this.advisor.Consideration.Detail
                : "",
            absolutePosition: { x: 230, y: 487 },
            fontSize: 10,
          },
          {
            text: this.advisor.Consideration.Status == 1 ? "/" : "",
            absolutePosition: { x: 115, y: 504 },
            fontSize: 10,
          },
          {
            text:
              this.advisor.Consideration.Status == 1
                ? this.advisor.Consideration.Detail
                : "",
            absolutePosition: { x: 210, y: 502 },
            fontSize: 10,
          },
          {
            image: `advisorSignature`,
            height: 35,
            width: 100,
            absolutePosition: { x: 380, y: 555 },
          },
          {
            text: this.advisor.Signature.Name,
            absolutePosition: { x: 400, y: 599 },
            fontSize: 10,
          },
          {
            text: this.advisor.Signature.Phone,
            absolutePosition: { x: 415, y: 615 },
            fontSize: 10,
          },
          {
            text: this.advisor.Signature.Date,
            absolutePosition: { x: 415, y: 631 },
            fontSize: 10,
          },
        ],
        defaultStyle: {
          font: "Sarabun",
        },
        styles: {
          header: {
            fontSize: 13,
            alignment: "center",
            bold: true,
          },
          Subheader: {
            fontSize: 12,
            alignment: "left",
            decoration: "underline",
            bold: true,
          },
          Normal: {
            fontSize: 8,
            alignment: "left",
            bold: false,
          },
          center: {
            alignment: "center",
          },
        },
        images: {
          // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
          // profile: this.scholarship.Profile.Image,
          background1: `${BaseURL}/images/bg/schorlarship1.jpg`,
          background2: `${BaseURL}/images/bg/schorlarship2.jpg`,
          background3: `${BaseURL}/images/bg/schorlarship3.jpg`,
          background4: `${BaseURL}/images/bg/schorlarship4.jpg`,
          // background5: `${BaseURL}/images/bg/schorlarship5.jpg`,
          background5: `${BaseURL}/images/bg/schorlarship6.jpg`,
          background6: `${BaseURL}/images/bg/schorlarship7.jpg`,
          // mapLocations: `${this.scholarship.mapLocations}`,
          studentSignature: `${this.scholarship.Signature.SignatureImage}`,
          // studentProfile: `${this.scholarship.Profile.Image}`,
          incomeSignature: `${this.income.Signature.SignatureImage}`,
          advisorSignature: `${this.advisor.Signature.SignatureImage}`,
        },
      };
      // // Upload PDF
      // await pdfMake.createPdf(docDefinition).open({}, window);
      const pdfDocGenerator = await pdfMake.createPdf(docDefinition);
      await pdfDocGenerator.getBlob(async (blob) => {
        const BaseAPI = this.BaseAPI;
        const BaseURL = this.BaseURL;
        let FileName = "";
        const UID = this.RandomID;
        const data = new FormData();
        data.append("fileUpload", blob, "pdfFile.pdf");
        data.append("fileName", "studentDetail");
        data.append("target", UID);
        data.append("subtarget", "profile");
        const url = `${BaseAPI}/uploadFileDetail.php`;
        const header = { headers: { "Content-Type": "multipart/form-data" } };
        await axios.post(url, data, header).then((response) => {
          FileName = `${BaseURL}images/save/assets/img/${UID}/${folder}/${response.data.response}.${response.data.type}`;
        });
        this.PDFName = FileName;
      });
    },

    async mapData() {
      let scholarship = sessionStorage.getItem("dataI1");
      let income = sessionStorage.getItem("dataI2");
      let advisor = sessionStorage.getItem("dataI3");
      let RandomID = sessionStorage.getItem("UID");
      let filelist = sessionStorage.getItem("fileList");
      this.scholarship = JSON.parse(scholarship);
      this.income = JSON.parse(income);
      this.advisor = JSON.parse(advisor);
      this.RandomID = RandomID;
      this.filelist = JSON.parse(filelist);
    },
    mapDataSiblingEducationAndCareer() {
      let Data = [];
      for (let i = 0; i < this.scholarship.SiblingEducationAndCareer.length; i++) {
        Data.push([
          {
            text: this.scholarship.SiblingEducationAndCareer[i].Gender,
            alignment: "center",
          },
          {
            text: this.scholarship.SiblingEducationAndCareer[i].Workplace,
            alignment: "center",
          },
          {
            text: this.scholarship.SiblingEducationAndCareer[i].Education,
            alignment: "center",
          },
          {
            text: this.scholarship.SiblingEducationAndCareer[i].AverageMonthlyIncome,
            alignment: "center",
          },
        ]);
      }
      return Data;
    },
    async sendEmail() {
      const url = this.BaseAPI;
      const data = new FormData();
      data.append("scholarship", this.PDFName);
      data.append("map", this.scholarship.mapLocations);
      data.append("profile", this.scholarship.Profile.Image);
      data.append("studenDetail", this.filelist.fileCardStudent);
      data.append("studenGPA", this.filelist.fileCardGPA);
      data.append("familyDetail", this.filelist.fileCardFamily);
      data.append("incomeCertifier", this.filelist.fileCardApproved);
      const header = { headers: { "Content-Type": "multipart/form-data" } };
      await axios.post(url, data, header).then((response) => {
        console.log(response.data);
        // setTimeout(() => {
        //   sessionStorage.clear();
        //   window.location.href = this.BaseURL;
        // }, 4000);
      });
    },
  },
};
</script>
<style scoped>
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 3px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
.p-500 {
  padding: 12rem 0;
}
.w-100vh {
  height: 100vh !important;
}
</style>
